import React, { createContext, useState, useContext } from "react";

const FlowIDContext = createContext();

// Export the hook to access the FlowID context
export const useFlowID = () => useContext(FlowIDContext);

// Provider component to wrap around the app
export const FlowIDProvider = ({ children }) => {
  // Get a valid FlowId from URL
  const getFlowId = () => {
    const maxFlowId = 500; // Safe hard-limit
    const params = new URLSearchParams(window.location.search);
    const urlFlowId = parseInt(params.get("flowId"), 10);
    if (
      !isNaN(urlFlowId) &&
      Number.isInteger(urlFlowId) &&
      urlFlowId >= 0 &&
      urlFlowId <= maxFlowId
    ) {
      return urlFlowId;
    } else {
      return 0;
    }
  };
  const [flowId] = useState(getFlowId);

  return (
    <FlowIDContext.Provider value={flowId}>{children}</FlowIDContext.Provider>
  );
};
